(function () {
  'use strict'

  const path = window.location.pathname || ''
  if (!path.endsWith('email-aenderung-bestaetigen.html')) {
    return
  }

  const ALERT_MS = 5000

  function hideAlerts () {
    $('#lgsuccess, #lgwarning, #lgerror').addClass('hidden').empty()
  }

  function showError (html, autoHide) {
    $('#lgwarning').addClass('hidden').empty()
    $('#lgerror').removeClass('hidden').html(html)
    if (autoHide) {
      setTimeout(function () {
        $('#lgerror').addClass('hidden').empty()
      }, ALERT_MS)
    }
  }

  function getTokenIdFromUrl () {
    const params = new URLSearchParams(window.location.search)
    return (params.get('token') || params.get('tokenId') || params.get('tokenPin') || '').trim()
  }

  $(document).ready(function () {
    const tokenId = getTokenIdFromUrl()
    if (!tokenId) {
      hideAlerts()
      showError(
        'Der Link ist ungültig oder unvollständig (Parameter <strong>token</strong>, <strong>tokenId</strong> oder <strong>tokenPin</strong> fehlt). Bitte verwenden Sie den vollständigen Link aus Ihrer E-Mail.',
        false
      )
      $('#confirmEmailChangeButton').prop('disabled', true)
      return
    }

    $('#confirmEmailChangeButton').on('click', function () {
      const $btn = $(this).prop('disabled', true).text('Wird übernommen …')
      hideAlerts()
      $.ajax({
        method: 'POST',
        url: '/auth/complete-account-identifier-change',
        contentType: 'application/json; charset=UTF-8',
        data: JSON.stringify({ token: tokenId }),
        global: false
      }).done(function (res) {
        if (res && res.success) {
          // Alte Session ungültig (Kennung geändert); sonst leitet base.js von index.html wieder ins Cockpit
          localStorage.removeItem('token')
          localStorage.removeItem('user')
          localStorage.removeItem('api')
          localStorage.removeItem('jwt')
          localStorage.removeItem('jwtToken')
          $('#lgerror, #lgwarning').addClass('hidden').empty()
          $('#lgsuccess')
            .removeClass('hidden')
            .html('Ihre neue E-Mail-Adresse ist übernommen. Sie können sich jetzt damit anmelden. Sie werden in Kürze zur Anmeldung weitergeleitet …')
          $('#confirmEmailSubline').hide()
          $('#confirmEmailChangeForm .hint').hide()
          $btn.hide()
          setTimeout(function () {
            window.location.href = './index.html'
          }, 5000)
        } else {
          const msg = (res && res.error) ? res.error : 'Die Bestätigung ist fehlgeschlagen.'
          showError(msg, true)
          $btn.prop('disabled', false).text('Änderung jetzt übernehmen')
        }
      }).fail(function (xhr) {
        const msg =
          xhr.responseJSON && xhr.responseJSON.error
            ? xhr.responseJSON.error
            : xhr.statusText || 'Die Bestätigung ist fehlgeschlagen.'
        showError(msg, true)
        $btn.prop('disabled', false).text('Änderung jetzt übernehmen')
      })
    })
  })
})()
